import React, { useEffect, useState } from "react";

const MinorWeightQuestion = ({ onSubmit, onNext, initialValue }) => {
    const [w, setW] = useState("");
    const [err, setErr] = useState("");
    const inputRef = React.useRef(null);

    useEffect(() => {
        if (initialValue) setW(String(initialValue));
    }, [initialValue]);

    // Delayed autofocus to allow smooth transition
    useEffect(() => {
        const timer = setTimeout(() => {
            inputRef.current?.focus();
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    const validate = (v) => {
        if (!v) return "This field is required.";
        const n = Number(v);
        if (!Number.isFinite(n) || n <= 0 || n > 400) return "Please enter a valid weight.";
        return "";
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const eMsg = validate(w);
        setErr(eMsg);
        if (eMsg) return;
        onSubmit(Number(w));
        onNext();
        setW(""); setErr("");
    };

    return (
        <form onSubmit={handleSubmit} className="input-form">
            <div className="dual-input-container" style={{ alignItems: "flex-end" }}>
                <div className="input-group" style={{ width: "100%" }}>
                    <label className="input-label">Minor's weight (lbs)</label>
                    <input
                        type="number"
                        inputMode="decimal"
                        className={`input-field ${err ? "input-error" : ""}`}
                        value={w}
                        onChange={(e) => { setW(e.target.value); if (err) setErr(""); }}
                        placeholder="Enter a number…"
                        ref={inputRef}
                    />
                    {err && <div className="error-message">{err}</div>}
                </div>
                <button type="submit" className="send-button dual-input-button" disabled={Boolean(validate(w))}>
                    Continue
                </button>
            </div>
        </form>
    );
};

export default MinorWeightQuestion;
